import React from "react";
import axios from "axios"
import semver from "semver";
import UpdatePackage from "./UpdatePackage";
import Loader from "./Loader";

const Provisioning = ({ provisioningprofile, session, onSuccess }) => {

    const states = {
        FETCHCONFIG: 1,
        PROVISIONING: 2,
        FINISHED: 3,
    };

    const [storeManifest, setStoreManifest] = React.useState();
    const [installedPackages, setInstalledPackages] = React.useState();
    const [provisioningProfile, setProvisioningProfile] = React.useState();
    const [toUpdate, setToUpdate] = React.useState();
    const [viewState, setViewState] = React.useState(states.FETCHCONFIG);

    const printState = (state) => {
        const foundKey = Object.keys(states).find((k) => {
            return states[k] === state;
        });
        return foundKey;
    }

    const transitionTo = (newState) => {
        console.log(`Provisioning : going from state  ${printState(viewState)} to ${printState(newState)}`);
        if (viewState === newState) {
            console.log(`from and to state are the same`);
            return;
        }
        switch (newState) {
            case states.PROVISIONING:
                if ([states.FETCHCONFIG].includes(viewState))
                    setViewState(newState);
                break;
            case states.FINISHED:
                if ([states.PROVISIONING].includes(viewState)) {
                    setViewState(newState);
                }
                onSuccess();
                break;
            default:
                console.log("unknown target state");
        }
    }


    React.useEffect(() => {
        if (session) {
            getPackages();
            getStore();
            getProvisioning();
        }
    }, [session]);

    React.useEffect(() => {
        if (storeManifest && installedPackages && provisioningProfile) {
            console.log(`applying provisioning profile`);
            transitionTo(states.PROVISIONING);

            let toUpdate = provisioningProfile.packages //.sort((a, b) => { console.log(a.name); return (a.name > b.name) ? 1 : -1 })
                .reduce((accum, p, i) => {
                    const installedVersion = installedPackages.find((installedPackage) => {
                        return (p === installedPackage.name)
                    })
                    if (!installedVersion) {
                        const manifestToInstall = storeManifest.packages.find((manifestPackage) => {
                            return (manifestPackage.manifest.name === p)
                        })

                        if (manifestToInstall) {
                            console.log(`found suitable package`, manifestToInstall)
                            accum.push(`${manifestToInstall.manifest.name}@${manifestToInstall.manifesthash}`);
                        }
                    }
                    return accum;
                }, []);

            toUpdate = [
                ...toUpdate,
                ...(provisioningProfile.packageids || [])
            ]

            console.log(`packackges to provision`, toUpdate);

            setToUpdate(toUpdate);
        }
    }, [storeManifest, installedPackages, provisioningProfile]);

    // const peerConnect = (peer) => {
    //     console.log(`connecting to IPFS ${peer}`);
    //     transitionTo(states.PROVISIONING);
    //     const apiLink = `http://my.ipfs.dnp.dappnode.eth:5001/api/v0/swarm/connect?arg=${peer}`;
    //     axios
    //         .get(
    //             apiLink
    //         )
    //         .then(res => {
    //             // console.log(res.data);
    //         })
    //         .catch(error => {
    //             console.log(`Failed to connect to ${apiLink}`, error.message);
    //         });
    // };


    const getProvisioning = async () => {
        try {
            const r = await axios.get(`https://bo.ava.do/value/provisioning-${provisioningprofile}`);

            const provisionProfile = JSON.parse(r.data);

            console.log(provisionProfile);
            setProvisioningProfile(provisionProfile);

        } catch (e) {
            console.log("Failed to get provisioning profile",e);
            // setError(`Cannot download store`);
        }
    }


    const getStore = async () => {
        try {
            const r = await axios.get("https://bo.ava.do/value/store");

            const storeRes = JSON.parse(r.data);

            // if (storeRes && storeRes.ipfsHostNodes) {
            //     storeRes.ipfsHostNodes.map(peerConnect);
            // }

            const storeHash = storeRes.hash;
            axios
                .get(
                    `http://172.33.1.5:8080/ipfs/${storeHash}`
                )
                .then(res => {
                    const storeManifest = res.data;
                    setStoreManifest(storeManifest);
                })
                .catch(error => {
                    console.log(error);
                });

        } catch (e) {
            // setError(`Cannot download store`);
        }
    }

    const getPackages = () => {
        session.call("listPackages.dappmanager.dnp.dappnode.eth")
            .then(res => {
                res = JSON.parse(res);
                if (!res || !res.result) {
                    throw new Error(`cannot find any packages on your AVADO`);
                }
                setInstalledPackages(res.result);
            })
            .catch((e) => {
                console.log(`${e.messsage}`);
            });
    };

    if (viewState === states.FETCHCONFIG) {
        return (<div>Fetching provisioning profile<Loader /></div>);
    }

    if (viewState === states.PROVISIONING) {
        if (!toUpdate || toUpdate.length === 0) {
            transitionTo(states.FINISHED);
            return null;
        }
        const packageToUpdate = toUpdate[0];
        // console.log(`pacage to  update=`, toUpdate);
        // return (null);
        return (
            <>
                <UpdatePackage id={packageToUpdate} session={session} onSuccess={(updatedPackage) => {
                    const filteredList = toUpdate.filter(item => item !== updatedPackage);
                    setToUpdate(filteredList);
                    console.log(`updated ${updatedPackage}`)
                    console.log(`remaining`,filteredList);
                    if (filteredList.length === 0){
                        transitionTo(states.FINISHED);
                    }
                }} /><br />
                <p>{toUpdate.length} update{toUpdate.length > 1 ? "s" : ""} remaining</p>
            </>
        );
    }

    if (viewState === states.FINISHED) {
        return (<div>Provisioning done</div>);
    }

    console.log()
}

export default Provisioning;
